import superagent from 'superagent';
import { getUserToken } from 'utils/authHeader';
import { unauthorizedRedirect } from 'utils/unauthorizedRedirect';
import _ from "lodash"
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listTestimonial = async ({ limit, page, testimonial_id, isactive }) => {
  let testimonialApi = superagent
    .get(`${BASE_URL}/testimonial/list`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .query({ page })
    .query({ limit });

  if (testimonial_id) {
    testimonialApi.query({ testimonial_id });
  }
  if (!_.isNil(isactive)) {
    testimonialApi.query({ isactive });
  }
  return await testimonialApi;
};

export const addTestimonial = async (payload) => {
  return await superagent
    .post(`${BASE_URL}/testimonial/create`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .use(unauthorizedRedirect)
    .send(payload)
    .retry(2);
};

export const editTestimonial = async (payload) => {
  return await superagent
    .put(`${BASE_URL}/testimonial/edit`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .use(unauthorizedRedirect)
    .send(payload)
    .retry(2);
};
export const deleteTestimonial = async (quote_id) => {
  return await superagent
    .delete(`${BASE_URL}/testimonial/delete`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .send({ quote_id })
    .retry(2);
};
